<template>
  <div>
    <van-dialog
      use-slot
      v-model="showDialog"
      :show-cancel-button="false"
      :show-confirm-button="false"
      :use-title-slot="true"
      :class="[
        'coupon-popup-dialog',
        isDesktop ? 'desktop-layout' : 'mobile-layout',
        displayHorizontal ? 'horizontal' : '',
      ]"
      :close-on-click-overlay="closeOnClickOverlay"
      @close="handleClose"
    >
      <template>
        <img
          class="coupon-header-img"
          :src="require(`@/assets/images/activities/coupon/guide-header.png`)"
          alt="icon"
        />
        <section class="coupon-popup-body">
          <template v-if="showName">
            <p class="coupon-name">{{ activityInfo.activityName }}</p>
            <p class="coupon-sub-name">{{ activityInfo.activityDesc }}</p>
          </template>
          <template v-else>
            <p class="coupon-name canWrap">
              {{ $t('coupon.congratulationsCoupon') }}
            </p>
          </template>
          <ul class="coupon-list-wrapper">
            <li class="coupon-item" v-for="item in couponList" :key="item.id">
              <template>
                <!-- 立减券  -->
                <p class="coupon-price" v-if="item.couponType * 1 === 1">
                  <!-- {{ item.currency + " " +item.couponPrice}} -->
                  <money-display
                    :useConfig="true"
                    :data="{
                      number: item.couponPrice,
                      currency: item.currency,
                    }"
                    :needHandle="true"
                  />
                </p>
                <!-- 折扣券  -->
                <p class="coupon-price" v-else>
                  {{ 100 - item.couponDiscount + '%OFF' }}
                </p>
                <p class="coupon-desc">
                  {{
                    $t('coupon.discount_condition3', {
                      currencySymbol: item.currency,
                      amount: formatMoney(item.conditionPrice),
                    })
                  }}
                </p>
                <p class="coupon-time">
                  <span class="time">
                    <!-- 固定天数 -->
                    <template v-if="item.timeType * 1 === 1">
                      {{ nowTime() }}--{{ nowTime(item.timeEffective) }}
                    </template>
                    <!-- 固定日期 -->
                    <template v-else>{{ getPeriod(item) }}</template>
                  </span>
                </p>
              </template>
            </li>
          </ul>
          <!-- 登录领取按钮 -->
          <button
            class="coupon-use-btn"
            @click="toUseCoupon"
            v-if="!(userInfo && userInfo.kicoinId)"
          >
            {{ $t('common.login') }}
          </button>
          <template><slot name="footDesc"></slot></template>
        </section>
        <van-icon
          name="close"
          color="#fff6f666"
          size="32"
          class="close-coupon-popup"
          @click="handleClose"
        />
      </template>
    </van-dialog>
  </div>
</template>

<script>
  import dayjs from 'dayjs'
  import { mapState, mapMutations } from 'vuex'
  import MoneyDisplay from '@/components/MoneyDisplay'
  import couponMixins from '@/mixins/coupon'
  import { PQ, Message } from '@/utils/priorityQueue'
  import { mapGetters } from 'vuex'
  import { getDateConfig } from '@/utils/dateConfig'

  const popup_id = 'coupon-popup'

  export default {
    mixins: [couponMixins],
    props: {
      dataSource: {
        type: Object,
        default: () => {},
      },
      show: {
        type: Boolean,
        default: false,
      },
      showName: {
        type: Boolean,
        default: true,
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      MoneyDisplay,
    },
    data() {
      return {
        showDialog: this.show,
      }
    },
    watch: {
      show(val) {
        if (val) {
          PQ.enqueue({
            id: popup_id,
            priority: 3.9,
          })
        } else {
          this.showDialog = false
          this.$emit('popupShow', false)
          PQ.close(popup_id)
        }
      },
    },
    computed: {
      ...mapState(['userInfo', 'isDesktop']),
      ...mapGetters(['displayHorizontal']),
      activityInfo() {
        return this.dataSource.activity || {}
      },
      couponList() {
        return this.dataSource.couponList || []
      },
    },
    mounted() {
      Message.receive((res) => {
        const { id } = res || {}
        if (id === popup_id) {
          this.showDialog = true
          this.$emit('popupShow', true)
          PQ.open(popup_id)
        }
      })
    },
    methods: {
      ...mapMutations(['setCouponDisplayStatus']),
      formatMoney(money = 0) {
        return this.$options.filters['formatMoney'](money)
      },
      nowTime(time = 0) {
        const now = dayjs()
        const feature = now.add(time, 'day')
        const time_format = getDateConfig().year_day
        return this.$options.filters['formatTime'](feature.unix(), time_format)
      },
      getTime(time) {
        let str = this.$options.filters['formatTime'](time).substring(0, 10)
        return str.replace('-', '.')
      },
      toUseCoupon() {
        this.$emit('toUse')
      },
      handleClose() {
        this.setCouponDisplayStatus(true)
        this.$emit('close')
      },
    },
  }
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
